import type { BaseComponent, Building, PhotoLocation } from '../types/protocols';

/** What the satellite image is called next to the drawings (pills, pickers). */
export const SATELLITE_LABEL = 'Satellit';

/**
 * A component's pin on the building's current satellite image
 * (`mapLocations/{currentMapImageKey}`), shaped as a PhotoLocation so it can be
 * shown with PhotoThumbnailWithMarker like a photo pin. Null when the building
 * has no map image or the component is not placed on the current one.
 */
export const satellitePhotoLocation = (
    component: Pick<BaseComponent, 'key' | 'mapLocations'>,
    building: Building | null | undefined,
): PhotoLocation | null => {
    const mapImageKey = building?.model?.currentMapImageKey;
    if (!mapImageKey) return null;
    const mapImage = building.model.mapImages?.[mapImageKey];
    const mapLoc = component.mapLocations?.[mapImageKey];
    if (!mapImage || !mapLoc) return null;
    return {
        parentKey: component.key,
        storagePath: mapImage.storagePath,
        width: mapLoc.width,
        height: mapLoc.height,
        x: mapLoc.x,
        y: mapLoc.y,
    };
};
